
import { PAGEVIEW_SEARCH_RESULT } from '@/utils/amplitudeEvent/amplitudeEvents.js';
import getFilterLogText from '@/utils/filter/getFilterLogText';
import { getLastClickSection } from '@/utils/localStorageUtils.js';
import { getPathFrom } from '@/utils/path';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import NoResult from '@/components/common/NoResult';
import HorizontalSearchSkeleton from '@/components/skeleton/HorizontalSearchSkeleton';
import EmptySearchFromNative from './EmptySearchFromNative.vue';
import EmptySearchFromProduct from './EmptySearchFromProduct.vue';

import InfiniteSearchListItem from './InfiniteSearchListItem.vue';

export default {
  name: 'InfiniteScrollSection',
  components: {
    HorizontalSearchSkeleton,
    NoResult,
    InfiniteSearchListItem,
    EmptySearchFromNative,
    EmptySearchFromProduct,
  },
  data() {
    return {
      infiniteId: +new Date(), // 탭 변경 시 infinite-scroll 초기화를 위한 id(이거 없으면, 탭 바꿨을 때, 무한 스크롤 안 됨. 문서대로 구현한 것.)
      skeletonListLength: 5, // 스켈레톤 아이템을 몇개까지 그릴지
      iob: null,
      isError: false,
    };
  },
  async fetch() {
    if (!process.client) return;
    try {
      const searchDate = await this.fetchSearchList(this.$route.query);
      this.SET_SEARCH_LIST(searchDate?.items || []);
      this.eventLog();
      this.setIsError(false);
    } catch (error) {
      console.error(error);
      this.setIsError(true);
      throw error;
    }
  },
  computed: {
    ...mapGetters('search', [
      'totalPages',
      'currentPage',
      'searchList',
      'isEmptySearchResult',
      'buttonTypeFromProduct',
      'activeBottomDrawerFilter',
      'isLoading',
      'totalSearchCount',
      'availableClassCount',
      'soldOutClassCount',
      'preparingClassCount',
      'maxScore',
    ]),
    ...mapGetters('filter', ['categoryList']),
  },
  watch: {
    async $route(to) {
      if (to?.name !== 'search') return;
      if (!to.query?.order) return;
      if (this.isLoading) return;
      this.RESET_SEARCH();
      this.SET_KEYWORD(to.query?.keyword || '');
      await this.$fetch();
    },
  },
  async created() {
    await this.$fetch();
  },
  methods: {
    ...mapActions('search', ['fetchSearchList']),
    ...mapMutations('search/filter', ['SET_KEYWORD']),
    ...mapMutations('search', ['RESET_SEARCH', 'SET_SEARCH_LIST']),
    async addFetch() {
      try {
        const res = await this.fetchSearchList(this.$route.query);
        if (!res) {
          this.setIsError(true);
          return;
        }
        this.SET_SEARCH_LIST([...this.searchList, ...res?.items]);
        this.setIsError(false);
      } catch (error) {
        console.error(error);
        this.setIsError(true);
      }
    },
    setIsError(bool) {
      this.isError = bool;
    },
    eventLog() {
      const inputKeyword = this.$nuxt.$route.query.keyword;
      const from = this.$nuxt.$route.query.from;
      const bestKeyword = from === 'best' ? inputKeyword : '';
      const recommendKeyword = from === 'recommend' ? inputKeyword : '';
      const eventProperties = {
        result: !this.isEmptySearchResult,
        from: this.buttonTypeFromProduct || getPathFrom(this.$nuxt.context), // from 수업 상세 페이지 > 스케줄 리스트 영역에 노출되는 버튼으로 검색 페이지가 유입된 경우에만 'same_schedule', 'set_schedule' 값으로 route.query에서 사용됩니다.
        section: getLastClickSection(),
        ...getFilterLogText({ ...this.$route.query }, this.categoryList),
        result_count_all: this.totalSearchCount, // 해당 검색 결과수 총합
        result_count_available: this.availableClassCount, // 신청가능한 결과수
        result_count_soldout: this.soldOutClassCount, // 전석매진된 결과수
        result_count_preparing: this.preparingClassCount, // 스케줄 준비중 결과수
        result_max_score: this.maxScore, // 해당 검색 결과에서의 최상위 결과의 추천 지수
      }
      if (!bestKeyword && !recommendKeyword) { // 직접 입력한 검색어
        eventProperties.input_keyword = inputKeyword;
      }
      if (bestKeyword) { // 인기 키워드 클릭시
        eventProperties.click_best_keyword = bestKeyword;
      }
      if (recommendKeyword) { // 추천 키워드 클릭시
        eventProperties.click_recommend_keyword = recommendKeyword;
      }
      delete eventProperties.keyword;

      this.logUserCustomEvent(PAGEVIEW_SEARCH_RESULT, eventProperties);
    },

    // onSetHide() {
    //   this.isCurationHide = true;
    // },
  },
};
